import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { Purchase } from "../purchase/type";

export default function PurchaseDetailButton(
  props: GridCellParams<Purchase, any>
) {
  return (
    <Link component={RouterLink} to={props.row.id.toString()}>
      Detay
    </Link>
  );
}
